<script lang="ts">
  import { Link } from "svelte-navigator";
  import { post_index, image_index } from "./images.json";
  export let postID;
  export let selected;

  const post = post_index[postID];
  const shortcode = post.image_shortcodes[0];
  const title =
    post.description.length > 25
      ? `${post.description.substring(0, 25)}...`
      : post.description;
</script>

{#if selected}
  <img
    class="selected"
    src="__IMAGES_BASE__/thumbnails/{shortcode}.jpg"
    alt={post.description} />
{:else}
  <Link
    to="/art/{shortcode}"
    title="View full size image with caption '{title}'">
    <img
      src="__IMAGES_BASE__/thumbnails/{shortcode}.jpg"
      alt={post.description} />
  </Link>
{/if}

<style>
  img {
    max-width: 10vw;
    padding: 0 1px 1px 0;
  }

  img:not(.selected):hover,
  img:not(.selected):active {
    filter: brightness(75%);
  }

  img.selected {
    opacity: 1;
    filter: brightness(50%);
  }
</style>
